import styled from 'styled-components';

export const TransparentBtn = styled.div`
  border: 2px solid #00558C;
  background-color: transparent;
  width: 270px;
  height: 50px;
  line-height: 45px;
  border-radius: 4px;
  margin-top: 34px;
  display: inline-block;

  a {
    display: block;
    color: #00558C
    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 1px;
    width: 100%;
    height: 100%;
  }
`;


export const PageHeading = styled.h2`
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 30px;
  font-weight: 500;
`;



// WEBPACK FOOTER //
// ./src/components/confirmation-page/styles.js